<template>
	<div class="content-wrapper">
		<template v-if="isLoaded">
			<div class="sf-flex-column h-100">
				<div class="sf-col sf-col-4">
					<sf-card class="p-0 h-100 card_bg">
						<search-view
							ref="searchView"
							@Refresh="refresh"
							:scrId="scrId"
							:flgOsGrp="this.flgOsGrp"
							:flgPqyapGrp="this.flgPqyapGrp"
							:flgPqyrvGrp="this.flgPqyrvGrp"
							:flgPqyrgGrp="this.flgPqyrgGrp"
							:flgPqycpGrp="this.flgPqycpGrp"
							:flgPqypoGrp="this.flgPqypoGrp"
							:flgHmcrdGrp="this.flgHmcrdGrp"
							:flgPqylpGrp="this.flgPqylpGrp"
							:flgPqyipGrp="this.flgPqyipGrp"
						></search-view>
					</sf-card>
				</div>
				<div class="sf-col sf-col-20">
					<sf-card class="p-0 border-0 bg-transparent h-100">
						<table-view
							ref="tableView"
							@Refresh="refresh"
							:scrId="scrId"
							:flgOsGrp="this.flgOsGrp"
							:flgPqyapGrp="this.flgPqyapGrp"
							:flgPqyrvGrp="this.flgPqyrvGrp"
							:flgPqyrgGrp="this.flgPqyrgGrp"
							:flgPqycpGrp="this.flgPqycpGrp"
							:flgPqypoGrp="this.flgPqypoGrp"
							:flgHmcrdGrp="this.flgHmcrdGrp"
							:flgPqylpGrp="this.flgPqylpGrp"
							:flgPqyipGrp="this.flgPqyipGrp"
							@openPopup="openPopup"
						></table-view>
					</sf-card>
				</div>
				<popup-detail
					ref="popupRef"
					@Refresh="refresh2"
					:scrId="scrId"
					:flgOsGrp="this.flgOsGrp"
					:flgPqyapGrp="this.flgPqyapGrp"
					:flgPqyrvGrp="this.flgPqyrvGrp"
					:flgPqyrgGrp="this.flgPqyrgGrp"
					:flgPqycpGrp="this.flgPqycpGrp"
					:flgPqypoGrp="this.flgPqypoGrp"
					:flgHmcrdGrp="this.flgHmcrdGrp"
					:flgPqylpGrp="this.flgPqylpGrp"
					:flgPqyipGrp="this.flgPqyipGrp"
				></popup-detail>
			</div>
		</template>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';

import SearchView from './Search/Search';
import TableView from './Table/Table';
import PopupDetail from './Popup/Popup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false,
			flgOsGrp: false, //시스템관리자
			flgPqyapGrp: false, //관리자(승인)
			flgPqyrvGrp: false, //중간관리자(검토)
			flgPqyrgGrp: false, //업무담당자(작성)
			flgPqycpGrp: false, //외부사용자(협력업체)
			flgPqypoGrp: false,
			flgHmcrdGrp: false,
			flgPqylpGrp: false,
			flgPqyipGrp: false
		};
	},
	async created() {
		this.screen = this.screenArray.get(this.scrId);
		this.$sf_toggleLoading(true);
		this.isLoaded = false;
		try {
			await this.getOs(); // 시스템 총괄그룹
			await this.getPqyap(); //승인자그룹
			await this.getPqyrv(); //검토자그룹
			await this.getPqyrg(); //작성자그룹
			await this.getPqycp(); //외부사용자(협력업체) 그룹
			await this.getPqypo();
			await this.getHmcrd();
			await this.getPqylp();
			await this.getPqyip();
		} catch (error) {
			console.error(error);
		} finally {
			this.$sf_toggleLoading(false);
			this.isLoaded = true;
		}

		// console.log('확인할 데이터 >>> ', this.flgOsGrp, this.flgPqyrgGrp);
	},
	components: { SearchView, TableView, PopupDetail },
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		refresh() {
			this.$refs.searchView.searchList();
		},
		refresh2() {
			// 불량보고 목록에서 return될때
			this.$refs.searchView.searchList();
		},
		openPopup(row) {
			this.$refs.popupRef.open(row);
		},
		async getOs() {
			this.flgOsGrp = await this.inclUsrGrp_('OS'); //시스템 관리자
		},
		async getPqyap() {
			this.flgPqyapGrp = await this.inclUsrGrp_('PQYAP'); //생산품질 관리자(승인)
		},
		async getPqyrv() {
			this.flgPqyrvGrp = await this.inclUsrGrp_('PQYRV'); //생산품질 중간관리자(검토)
		},
		async getPqyrg() {
			this.flgPqyrgGrp = await this.inclUsrGrp_('PQYRG'); //생산품질 일반사용자(작성)
		},
		async getPqycp() {
			this.flgPqycpGrp = await this.inclUsrGrp_('PQYCP'); //생산품질 외부사용자(협력업체)
		},
		async getPqypo() {
			this.flgPqypoGrp = await this.inclUsrGrp_('PQYPO'); //생산품질 외부사용자(협력업체)
		},
		async getHmcrd() {
			this.flgHmcrdGrp = await this.inclUsrGrp_('HMCRD'); //생산품질 외부사용자(협력업체)
		},
		async getPqylp() {
			this.flgPqylpGrp = await this.inclUsrGrp_('PQYLP'); //생산품질 외부사용자(협력업체)
		},
		async getPqyip() {
			this.flgPqyipGrp = await this.inclUsrGrp_('PQYIP'); //생산품질 외부사용자(협력업체)
		}
	}
};
</script>

<style></style>
